/**
 * User-management types — mirror cx-alm DTOs.
 *
 * Server source of truth:
 *   services/cx-alm/.../presentation/dto/UserResponse.java
 *   services/cx-alm/.../presentation/dto/CreateUserRequest.java
 *   services/cx-alm/.../presentation/dto/ChangePasswordRequest.java
 *   services/cx-alm/.../presentation/dto/SetStatusRequest.java
 *   services/cx-alm/.../presentation/dto/MeResponse.java
 */

export type UserStatus = 'ACTIVE' | 'LOCKED' | 'DISABLED';

export type CubixRole =
  | 'ALM_ADMIN'
  | 'ALM_MANAGER'
  | 'ALM_ANALYST'
  | 'REPORT_VIEWER'
  | 'AUDITOR'
  | 'DATA_MANAGER';

export const ALL_ROLES: CubixRole[] = [
  'ALM_ADMIN',
  'ALM_MANAGER',
  'ALM_ANALYST',
  'REPORT_VIEWER',
  'AUDITOR',
  'DATA_MANAGER',
];

export interface UserResponse {
  userId: string;
  email: string;
  fullName?: string;
  status: UserStatus;
  tenantId: string;
  roles: CubixRole[];
  createdAt: string;
  createdBy: string;
}

export interface CreateUserRequest {
  userId: string;
  email: string;
  fullName?: string;
  password: string;
  role: CubixRole;
}

export interface ChangePasswordRequest {
  oldPassword?: string;
  newPassword: string;
}

export interface SetStatusRequest {
  status: UserStatus;
}

export interface MeResponse {
  userId: string;
  email?: string;
  tenantId: string;
  roles: CubixRole[];
  permissions?: string[];
  expEpoch?: number;
}
